import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface State {
  audioId: AudioFileId | null;
  waveIsReady: boolean;
  isAudioPlaying: boolean;
  isAudioOn: boolean;
  isMute: boolean;
  duration: Duration | null;
}

const initialState: State = {
  audioId: null,
  waveIsReady: false,
  isAudioPlaying: false,
  isAudioOn: false,
  isMute: true,
  duration: null,
};

// S L I C E

export const audioTrackSlice = createSlice({
  name: 'audio',
  initialState,
  reducers: {
    setAudioId: (state, action: PayloadAction<State['audioId']>) => {
      state.audioId = action.payload;
    },
    setWaveIsReady: (state, action: PayloadAction<boolean>) => {
      state.waveIsReady = action.payload;
    },
    setIsAudioPlaying: (state, action: PayloadAction<boolean>) => {
      state.isAudioPlaying = action.payload;
    },
    setIsAudioOn: (state, action: PayloadAction<boolean | undefined>) => {
      state.isAudioOn = action.payload ?? !state.isAudioOn;
    },
    setIsMute: (state, action: PayloadAction<boolean>) => {
      state.isMute = action.payload;
    },
    setDuration: (state, action: PayloadAction<State['duration']>) => {
      state.duration = action.payload;
    },
    resetAudioFile: (state) => {
      state.waveIsReady = false;
      state.duration = null;
    },
    resetAudioTrack: (state) => {
      const { waveIsReady, duration } = state;
      return { ...initialState, waveIsReady, duration };
    },
  },
});

export const {
  setAudioId,
  setWaveIsReady,
  setIsAudioPlaying,
  setIsAudioOn,
  setIsMute,
  setDuration,
  resetAudioFile,
  resetAudioTrack,
} = audioTrackSlice.actions;

export default audioTrackSlice.reducer;
